import { Box } from "@mui/material";
import React from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import api from "../../api/api";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import MuiHeader from "../../components/MuiHeader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const NsdcCert = () => {
  const navigate = useNavigate();
  const res = useSelector((state) => state.NsdcSlice.managers);
  // //console.log("res--->", res);
  const navigate_to = () => {
    navigate("/nsdc");
  };
  const [managerId, setmanagerId] = useState("");
  const [users, setUsers] = useState([]);
  //console.log("users---->", users);
  const [userId, setUserId] = useState("");
  //console.log("userId---->", userId);
  const [selected_files, setSelected_files] = useState({});
  //   //console.log("selected_files-->", selected_files);
  const [upload_success, set_upload_success] = useState(false);
  //  //console.log("upload_success-->", upload_success);

  const select_manager_change = (event) => {
    setmanagerId(event.target.value);
    api.get(`getnsdcappearedusers/${event.target.value}`).then((response) => {
      // //console.log("user response--->", response.data);
      setUsers(response.data.data);
    });
  };

  let im = [];
  // const [clear_image, set_clear_image] = useState("");
  // //console.log("clear_image-->", clear_image);
  // if (upload_success === true) {
  users.forEach((element) => {
    if (element._id === userId) {
      // //console.log("id checked");
      im = element.certificate;
    }
  });

  const select_User_change = (event) => {
    setUserId(event.target.value);
  };

  const handleChangeImage = (event) => {
    // event.preventDefault();
    // //console.log("event-->", event.target.files);
    setSelected_files(event.target.files);

    for (let i = 0; i < event.target.files.length; i++) {
      let displayname = event.target.files[i].name;
      //console.log("this.displayname-->", displayname);
      let filetype = displayname.split(".").pop();
      //console.log(" this.filetype-->", filetype);
      let s3name = new Date().getTime() + "." + filetype;
      //console.log("this.s3name-->", s3name);
      let currentFileUpload = event.target.files.item(i);
      //console.log(" this.currentFileUpload-->", currentFileUpload);
      //  let uploadurl = '';
      //  uploadurl = (directory == undefined || directory == null || directory == '') ? 's3api/uploadroot/'+s3name : 's3api/uploaddir/'+directory+'/'+s3name;
      var formData = new FormData();
      formData.append("file", currentFileUpload);
      //console.log("FormData-->", FormData);
      api.post(`s3api/uploadroot/${s3name}`, formData).then(
        (response) => {
          //console.log("response uplooad-->", response.data);
          set_get_s3name(response.data);
          let body = {
            certificate: response.data.s3path,
            certificatestatus: "complete",
          };
          api.put(`addnsdccert/${userId}`, body).then((response) => {
            //console.log("response after upload-->", response.data);
            if (response.data.status === "success") {
              alert("uploded successfully!!");
              event.target.value = null;
              // set_upload_success(true);
              api.get(`getnsdcappearedusers/${managerId}`).then((response) => {
                // //console.log("user response--->", response.data);
                setUsers(response.data.data);
              });
            }
          });
        },
        (err) => {
          //console.log(err);
        }
      );
    }
  };
  //console.log("event-ffff->", selected_files);
  const [s3_getname, set_get_s3name] = useState("");
  ////console.log("s3_getname-->", s3_getname);

  // const handleImageSave = () => {
  //   // //console.log("event log-->", x);
  //   // hideProgressbar = false;
  //   // progress.percentage = 0;
  //   for (let i = 0; i < selected_files.length; i++) {
  //     let displayname = selected_files[i].name;
  //     //console.log("this.displayname-->", displayname);
  //     let filetype = displayname.split(".").pop();
  //     //console.log(" this.filetype-->", filetype);
  //     let s3name = new Date().getTime() + "." + filetype;
  //     //console.log("this.s3name-->", s3name);
  //     let currentFileUpload = selected_files.item(i);
  //     //console.log(" this.currentFileUpload-->", currentFileUpload);
  //     //  let uploadurl = '';
  //     //  uploadurl = (directory == undefined || directory == null || directory == '') ? 's3api/uploadroot/'+s3name : 's3api/uploaddir/'+directory+'/'+s3name;
  //     var formData = new FormData();
  //     formData.append("file", currentFileUpload);
  //     //console.log("FormData-->", FormData);
  //     api.post(`s3api/uploadroot/${s3name}`, formData).then(
  //       (response) => {
  //         //console.log("response uplooad-->", response.data);
  //         set_get_s3name(response.data);
  //         let body = {
  //           certificate: response.data.s3path,
  //           certificatestatus: "complete",
  //         };
  //         api.put(`addnsdccert/${userId}`, body).then((response) => {
  //           //console.log("response after upload-->", response.data);
  //           if (response.data.status === "success") {
  //             alert("uploded successfully!!");
  //             // set_upload_success(true);
  //             api.get(`getnsdcappearedusers/${managerId}`).then((response) => {
  //               // //console.log("user response--->", response.data);
  //               setUsers(response.data.data);
  //             });
  //           }
  //         });
  //       },
  //       (err) => {
  //         //console.log(err);
  //       }
  //     );
  //   }
  // };

  const handleDelete = () => {
    //console.log("clicked");
    api.put(`deletensdccert/${userId}`).then((response) => {
      //console.log("delete response-->", response.data);
      if (response.data.status === "success") {
        //set_upload_success(false);
        // setSelected_files({})
        // handleChangeImage()
        api.get(`getnsdcappearedusers/${managerId}`).then((response) => {
          // //console.log("user response--->", response.data);
          setUsers(response.data.data);
          toast.success("Changes made successfully");
        });
      }
    });
  };

  return (
    <>
      <div>
        <MuiHeader header="NSDC Certificate" />
        {/* <h1>NSDC Certificate</h1> */}
        <Button
          onClick={navigate_to}
          variant="outlined"
          sx={{ m: 1, minWidth: 120, marginTop: 0 }}
          size="small"
        >
          Back
        </Button>
        <Box>
          <div style={{ marginTop: "70px" }}>
            <FormControl sx={{ m: 1, minWidth: 300, marginTop: 8 }} size="small">
              <InputLabel id="demo-select-small">Managers</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={managerId}
                label="Age"
                onChange={select_manager_change}
              >
                <MenuItem value="">
                  <em>Select Managers</em>
                </MenuItem>
                {res.map((element) => (
                  <MenuItem value={element.userid}>{element.username}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
            <InputLabel id="demo-select-small">Users</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={userId}
              label="Age"
              onChange={select_User_change}
            >
              <MenuItem value="">
                <em>Select Users</em>
              </MenuItem>
              {users.map((element) => (
                <MenuItem value={element._id}>{element.username}</MenuItem>
              ))}
            </Select>
          </FormControl>
          {userId ? (
            <div>
              <div style={styles.select}>
                <h2>Upload Certificate:</h2>
                <input
                  type="file"
                  style={styles.files}
                  onChange={handleChangeImage}
                />
                {/* {upload_success === true ? ( */}
                <img src={im} style={{ width: 120 }} />
                {/* ) : null} */}

                {/* <Button variant="contained" onClick={handleImageSave}>
              Save
            </Button> */}
                {im.length > 0 && (
                  <Button
                    variant="contained"
                    style={styles.buttons}
                    onClick={handleDelete}
                  >
                    Delete
                  </Button>
                )}
              </div>
            </div>
          ) : null}
        </Box>
        <ToastContainer />
      </div>
    </>
  );
};

export default NsdcCert;
const styles = {
  select: {
    border: "10px ridge grey ",
    width: "500px",
    marginLeft: "500px",
    marginTop: "-100px",
    textAlign: "center",
  },
  files: {
    marginLeft: "90px",
    padding: "10px",
    fontSize: "15px",
  },
  buttons: {
    marginTop: "233px",
    backgroundColor: "red",
    color: "black",
    // marginLeft: "-30px",
  },
};
